import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-[#0A1628] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/c07ed6529feea951012003251bff6ba4/cc46e5df510751817c67bd8191e21399.png" 
              alt="Company Logo" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {t('footer.copyright')}
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-400 hover:text-[#4d9c71] transition-colors cursor-pointer whitespace-nowrap">
                {t('footer.privacy')}
              </a>
              <a href="#" className="text-gray-400 hover:text-[#4d9c71] transition-colors cursor-pointer whitespace-nowrap">
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
